// Show an element
export const show = (elem) => {
  if (!elem) return;
  // eslint-disable-next-line no-param-reassign
  elem.style.display = 'block';
};

// Hide an element
export const hide = (elem) => {
  if (!elem) return;
  // eslint-disable-next-line no-param-reassign
  elem.style.display = 'none';
};

// Toggle element visibility
export const toggle = (elem) => {
  // If the element is visible, hide it
  if (window.getComputedStyle(elem).display === 'block') {
    hide(elem);
    return;
  }
  // Otherwise, show it
  show(elem);
};

export const onReady = (f) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', f);
  } else {
    f();
  }
};

export const throttle = (func, delay) => {
  let timeoutId = null;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
};

// KL-14636 follow-up: identifiable crawlers (Googlebot, Storebot-Google,
// Google-Read-Aloud, the Shap-User scraper, generic *bot/*crawler UAs) were
// found triggering real order rows + Meta/GA4 add_to_cart events just by
// GETting funnel pages — no purchase intent, pure noise that also polluted
// the KL-14636 investigation's order data. Only catches self-identifying
// UAs; a bot spoofing a normal browser string won't match.
const BOT_USER_AGENT_PATTERN = /bot|crawl|spider|slurp|storebot|read-aloud|headless|shap-user|facebookexternalhit/i;

export const isBotUserAgent = () => {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return false;
  return BOT_USER_AGENT_PATTERN.test(navigator.userAgent);
};
